import React, { useRef, useState } from "react";

const FileField = ({
  label,
  name,
  required,
  idField,
  onChangeHandler,
  multiple = false,
  description,
  explanation,
}) => {
  const fileInputIdField = idField
    ? idField + "-inputFile"
    : name + "-inputFile";
  const [fileList, setFileList] = useState(null);
  const fileEle = useRef(null);

  return (
    <>
      <div className="tps-form-question">
        <div className="tps-form-label">
          <label
            className={`fatv2-masthead-form-label form-control ${
              required
                ? "tps-field-required tps-to-validate"
                : "tps-not-required"
            }`}
            htmlFor={fileInputIdField}
          >
            {label}
          </label>
          {!!explanation && explanation !== "" && (
            <div className="fas fa-info-circle tps-form-tip has-tip">
              <div
                className="tooltiptext"
                dangerouslySetInnerHTML={{ __html: explanation }}
              ></div>
            </div>
          )}
          {!!fileList && (
            <>
              {Array.from(fileList).map((f, i) => (
                <a
                  key={i}
                  href="#"
                  className="tps-file-value"
                  onClick={(e) => {
                    e.preventDefault();
                    fileEle.current.value = null;
                    setFileList(null);
                  }}
                >
                  {f?.name}
                </a>
              ))}
            </>
          )}
        </div>
        <div className="tps-form-input">
          <input
            className="form-text fatv2-masthead-form-input"
            id={fileInputIdField}
            name={name}
            type="file"
            multiple={multiple}
            required={required}
            onChange={(event) => {
              onChangeHandler(event);
              setFileList(event.target.files);
            }}
            style={{ display: "none" }}
            ref={fileEle}
          />
          {!!description && description !== "" && (
            <p
              className="tps-form-input-explaination"
              dangerouslySetInnerHTML={{ __html: description }}
            ></p>
          )}
        </div>
      </div>
    </>
  );
};

export default FileField;
